import Page from 'containers/AttachPage'

export default Page
